"use client";

import { createContext, useCallback, useContext, useMemo, useState, type ReactNode } from "react";

type PendingFilesContextValue = {
  files: File[];
  setFiles: (files: File[]) => void;
  clear: () => void;
};

const PendingFilesContext = createContext<PendingFilesContextValue | null>(null);

// 待处理文件只在 SPA 会话内跨路由存活（Provider 挂在 root layout，路由切换不卸载）。
// 刷新 / 新标签页即为空，此时 /create 提示回首页重选（设计决策：完全不预上传）。
export function PendingFilesProvider({ children }: { children: ReactNode }) {
  const [files, setFilesState] = useState<File[]>([]);

  const setFiles = useCallback((next: File[]) => {
    setFilesState(next);
  }, []);

  const clear = useCallback(() => {
    setFilesState([]);
  }, []);

  const value = useMemo(() => ({ files, setFiles, clear }), [files, setFiles, clear]);

  return <PendingFilesContext.Provider value={value}>{children}</PendingFilesContext.Provider>;
}

export function usePendingFiles(): PendingFilesContextValue {
  const ctx = useContext(PendingFilesContext);
  if (!ctx) {
    throw new Error("usePendingFiles 必须在 PendingFilesProvider 内部使用");
  }
  return ctx;
}
